<template>
  <div class="modal-sticky-header" :class="{ 'is-mobile': isMobile, 'is-strip-collapsed': collapsed }">
    <slot name="topbar" />
    <button
      type="button"
      class="strip-toggle"
      :aria-expanded="String(!collapsed)"
      @click="toggle"
    >
      <v-icon size="16" color="#2D4B95">{{ collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
      {{ collapsed ? 'Ver estado' : 'Ocultar estado' }}
    </button>
    <div class="strip-region">
      <slot name="status-strip" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalStickyHeader',
  props: {
    breakpoint: {
      type: Number,
      default: 768
    }
  },
  data: () => ({
    isMobile: false,
    collapsed: true,
    mediaQuery: null
  }),
  created() {
    if (typeof window === 'undefined' || !window.matchMedia) return
    this.mediaQuery = window.matchMedia(`(max-width: ${this.breakpoint}px)`)
    this.isMobile = this.mediaQuery.matches
    this.mediaQuery.addEventListener('change', this.onMediaChange)
  },
  beforeDestroy() {
    if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.onMediaChange)
  },
  methods: {
    onMediaChange(event) {
      this.isMobile = event.matches
    },
    toggle() {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style scoped>
/* Desktop: el wrapper no genera caja, el layout original no cambia. */
.modal-sticky-header,
.strip-region {
  display: contents;
}
.strip-toggle {
  display: none;
}

.modal-sticky-header.is-mobile {
  display: block;
  position: sticky;
  top: 0;
  z-index: 20;
  flex-shrink: 0;
  background: #FAFBFF;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);
}
.is-mobile .strip-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 4px 16px;
  border: none;
  border-bottom: 1px solid #E5E8EF;
  background: #FAFBFF;
  color: #2D4B95;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.is-mobile .strip-region {
  display: block;
  max-height: 40vh;
  overflow-y: auto;
}
.is-mobile.is-strip-collapsed .strip-region {
  display: none;
}
</style>
